import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api, formatError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";


export default function Login() {
  const [email, setEmail] = useState("");
  const [pw, setPw] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();
  const { setUser } = useAuth();

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true);
    try {
      const { data } = await api.post("/auth/login", { email, password: pw });
      setUser(data);
      nav("/dashboard");
    } catch (e) {
      setErr(formatError(e.response?.data?.detail) || "Login failed");
    } finally { setBusy(false); }
  };


  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white grid md:grid-cols-2">
      <div className="hidden md:flex flex-col justify-between p-12 border-r border-zinc-900 bg-gradient-to-br from-[#0A0A0A] via-[#0A0A0A] to-[#007AFF]/10">
        <Link to="/" className="flex items-center gap-2" data-testid="login-logo">
          <img src="/brand/ptiq-icon.png" alt="ProTradeIQ" className="h-6 w-6 object-contain" />
          <span className="font-heading text-xl font-black uppercase">PROTRADE<span className="text-[#007AFF]">IQ</span></span>
        </Link>
        <div>
          <div className="text-xs font-mono tracking-[0.3em] text-[#007AFF] mb-4 uppercase">◢ Welcome back</div>
          <h2 className="font-heading text-5xl font-black uppercase tracking-tighter leading-none">
            Read the market.<br />Take the trade.
          </h2>
          <p className="mt-6 text-zinc-400 max-w-md">Your AI copilot is ready — every signal is scored, every headline is filtered for the instrument you trade.</p>
        </div>
        <div className="text-xs uppercase tracking-widest text-zinc-600">AI-powered intraday trading.</div>
      </div>

      <div className="flex items-center justify-center p-6 md:p-12">
        <form onSubmit={submit} className="w-full max-w-sm" data-testid="login-form">
          <h1 className="font-heading text-3xl font-bold uppercase tracking-tight">Sign in</h1>
          <p className="mt-2 text-sm text-zinc-400">Welcome back to ProTradeIQ.</p>

          <label className="mt-8 block text-xs uppercase tracking-widest text-zinc-400">Email</label>
          <input value={email} onChange={(e) => setEmail(e.target.value)} required type="email" className="mt-1 w-full bg-transparent border border-zinc-800 focus:border-[#007AFF] outline-none px-3 py-3 font-mono text-sm" data-testid="login-email" />

          <label className="text-xs uppercase tracking-widest text-zinc-400 mt-5 block">Password</label>
          <input value={pw} onChange={(e) => setPw(e.target.value)} required type="password" className="mt-1 w-full bg-transparent border border-zinc-800 focus:border-[#007AFF] outline-none px-3 py-3 font-mono text-sm" data-testid="login-password" />

          {err && <div className="mt-4 text-sm text-[#EF4444] border border-[#EF4444]/30 bg-[#EF4444]/5 px-3 py-2" data-testid="login-error">{err}</div>}

          <button disabled={busy} type="submit" className="mt-6 w-full bg-[#007AFF] text-white font-bold uppercase tracking-wider py-3 hover:bg-[#3395FF] transition-colors disabled:opacity-50" data-testid="login-submit">
            {busy ? "Signing in…" : "Sign in"}
          </button>

          <div className="mt-6 text-sm text-zinc-400 text-center">
            New here? <Link to="/signup" className="text-[#007AFF] hover:underline" data-testid="login-go-signup">Create an account</Link>
          </div>
        </form>
      </div>
    </div>
  );
}
